// Uberflip Outsource OB-10258 start here
import getTiles from "./filter/getTiles";
import { handleCheckboxChange } from "./filter/handleFiltering";

const handleFilterChange = () => {
    const ulContainer = document.querySelector('#onBrand__filter--form .onBrand__filter--dropdown');
    if(ulContainer){
        ulContainer.addEventListener('click', (e) => e.stopPropagation());
    }
    
    const handleDropdownChange = (e) =>{
        const { target } = e;

        // If the clicked target is the filter-remove button, exit the event listener
        if (target.classList.contains('filter-remove')) {
            return;
        }

        // Determine the parent of the target
        const targetParent = target.parentElement.classList.contains('filter-category') ?
            target.parentElement :
            target.parentElement.parentElement;

        const targetDropdown = targetParent.querySelector('.onBrand__filter--dropdown');
        const activeDropdowns = document.querySelector('.filter-category.active');

        // If an active dropdown exists and the target parent is the same, toggle it
        if (activeDropdowns !== null && targetParent === activeDropdowns) {
            targetParent.classList.toggle('active');
            $(targetDropdown).slideToggle(300);
        } else if (activeDropdowns !== null) {
            // Close the currently active dropdown, then open the clicked one
            const toBeToggled = activeDropdowns.querySelector('.onBrand__filter--dropdown');
            if (toBeToggled) {
                activeDropdowns.classList.remove('active');
                $(toBeToggled).slideToggle(300);
                setTimeout(() => {
                    targetParent.classList.toggle('active');
                    $(targetDropdown).slideToggle(300);
                }, 300);
            }
        } else {
            // No active dropdown, just open the clicked one
            targetParent.classList.toggle('active');
            $(targetDropdown).slideToggle(300);
        }
    };
    const dropdown = document.querySelectorAll('#onBrand__filter-wrapper #onBrand__filter--form #filter-title');
    dropdown.forEach((filter) => {
        filter.parentElement.addEventListener('click', (e) => handleDropdownChange(e));
    });

    // Close the dropdown if the user clicks outside of any active filter category
    document.addEventListener('click', (event) => {
        const activeDropdown = document.querySelector('.filter-category.active');

        // If the click is outside the active dropdown, close it
        if (activeDropdown && !activeDropdown.contains(event.target)) {
            activeDropdown.classList.remove('active');
            const dropdownToClose = activeDropdown.querySelector('.onBrand__filter--dropdown');
            if (dropdownToClose) {
                $(dropdownToClose).slideUp(300); // Close the dropdown with a slide-up animation
            }
        }
    });


    const closeDropdown = document.querySelectorAll('span.close_dropdown');
    if(closeDropdown) {
        closeDropdown.forEach((closeIcon) => {
            closeIcon.addEventListener('click', function(e) {
                e.preventDefault();
                const selected = closeIcon.parentElement.parentElement.querySelectorAll('input[type="checkbox"]:checked');
                if (selected) {
                    selected.forEach((input) => {
                        input.checked = false;
                    });
                    handleCheckboxChange();
                }
                const activeDropdown = document.querySelector('.filter-category.active');

                // If the click is outside the active dropdown, close it
                if (activeDropdown) {
                    activeDropdown.classList.remove('active');
                    const dropdownToClose = activeDropdown.querySelector('.onBrand__filter--dropdown');
                    if (dropdownToClose) {
                        $(dropdownToClose).slideUp(300); // Close the dropdown with a slide-up animation
                    }
                }
            });
        });
    }
    const resetButton = document.querySelector('.reset-button');
    if (resetButton) {
        resetButton.onclick = function(event) {
            event.preventDefault();
            $('#onBrand__filter--form input[type="checkbox"]').each(function() {
                $(this).prop('checked', false);
            });
            handleCheckboxChange();
            getTiles(this.translations);
        };
    }
};

export { handleFilterChange };

// Uberflip Outsource OB-10258 end here


// WEBPACK FOOTER //
// ./scriptPartials/handleFilterDropdown.js